/* eslint-disable no-lone-blocks */
import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{props.children}</>;
};

export default ScrollToTop;

{
  /* A gente ta trabalhando com as rotas para direcionar as paginas(acessar pagina equipe, resultados, referencias) 
o router ele não recarrega a pagina, então por isso quando chamamos uma das paginas a barra de rolagem continua na 
mesma posição de onde chamamos a nova pagina, por exemplo na pagina inicial temos a parte da equipe que fica no meio
da paginha e ali tem o botão para clicar para direcionar para pagina da equipe, para isso usamos o router. Se a gente
não fizer esse componente aqui que fizemos, ele vai direcionar para a pagina da equipe mas na posição da rolagem quando
foi clicado, ou seja, vai chamar no meio da pagina da equipe e isso não é o que queremos, queremos que quando chame
a nova pagina comece do inicio. Então para corrigir isso usamos esse componente aqui criado.
obs: La no componente principal que é o app.js temos que chamar esse componente aqui e envolver o Routes dentro dele
*/
}
